import {
    GET_PHOTO_ALBUM_LOADING,
    GET_PHOTO_ALBUM_SUCCESS,
    GET_PHOTO_ALBUM_FAILURE
} from '../../actions/types';

const INITIAL_STATE = {
    photos: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    }
};

const photoAlbumReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PHOTO_ALBUM_LOADING:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_PHOTO_ALBUM_SUCCESS:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_PHOTO_ALBUM_FAILURE:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
    }
    return state;
}

export default photoAlbumReducers;    